import { getCoreRowModel } from "@tanstack/react-table"
import { type FC } from "react"

import { useGoodsReceiptPurchaseOrderColumns } from "../../hooks"
import type { PurchaseOrderLineWithReceiptContext } from "../../types"
import { getGoodsReceiptPurchaseOrderLines } from "../../utils"

import { AerosBaseTable } from "@/components/Tables/Aeros/components/AerosBaseTable"
import type { GoodsReceipt } from "@/graphql/codegen/graphql"

interface GoodsReceiptPurchaseOrdersTableProps {
  goodsReceipt: GoodsReceipt
}

export const GoodsReceiptPurchaseOrdersTable: FC<GoodsReceiptPurchaseOrdersTableProps> = ({ goodsReceipt }) => {
  const purchaseOrderLines = getGoodsReceiptPurchaseOrderLines(goodsReceipt)

  const columns = useGoodsReceiptPurchaseOrderColumns()

  return (
    <AerosBaseTable<PurchaseOrderLineWithReceiptContext>
      slotProps={{
        headerCell: { className: "bg-primary-100" },
      }}
      features={{
        tanstackOptions: {
          data: purchaseOrderLines,
          columns,
          enableSorting: false,
          getCoreRowModel: getCoreRowModel(),
        },
      }}
      noDataMessage='No purchase orders found'
    />
  )
}
